import { useMemo } from "react";
import type { FC } from "react";

import { supportTicketReasonCategories } from "../create/supportTicketReasonCategories";
import {
  extraSupportTagOptions,
  getKnownSupportTagKeys,
  isBlockedSupportTag,
} from "./supportTagSuggestions";
import {
  SupportCategorizedCheckboxList,
  type SupportCategorizedCheckboxCategory,
} from "./SupportCategorizedCheckboxList";

type Props = {
  selectedTags: string[];
  onSelectedTagsChange: (selectedTags: string[]) => void;
};

export const SupportTagPickerContent: FC<Props> = ({ selectedTags, onSelectedTagsChange }) => {
  const categories = useMemo(() => {
    const result: SupportCategorizedCheckboxCategory[] = supportTicketReasonCategories.map((category) => ({
      id: category.id,
      label: category.label,
      options: category.options.map((option) => ({
        key: option.tag,
        label: option.label,
      })),
    }));

    if (extraSupportTagOptions.length > 0) {
      result.push({
        id: "inne-tagi",
        label: "Inne tagi",
        options: extraSupportTagOptions.map((option) => ({
          key: option.tag,
          label: option.label,
        })),
      });
    }

    const knownTagKeys = getKnownSupportTagKeys();
    const orphanTags = selectedTags.filter(
      (tag) => !knownTagKeys.has(tag.trim().toLowerCase()) && !isBlockedSupportTag(tag),
    );

    if (orphanTags.length > 0) {
      result.push({
        id: "pozostale",
        label: "Pozostałe",
        options: orphanTags.map((tag) => ({
          key: tag,
          label: tag,
        })),
      });
    }

    return result;
  }, [selectedTags]);

  return (
    <div css={{ flex: 1, minHeight: 0, height: "100%", display: "flex", flexDirection: "column" }}>
      <SupportCategorizedCheckboxList
        categories={categories}
        selectedKeys={selectedTags}
        onSelectedKeysChange={onSelectedTagsChange}
      />
    </div>
  );
};
